import DefaultContainer from "@/components/containers/DefaultContainer.vue";
import HomePage from "@/views/HomePage.vue";
import Page404 from "@/views/pages/Page404.vue";
import Vue from "vue";
import Router from "vue-router";

import { managementRouteConfig } from "./apps/management/routeConfig";
import { plmRouteConfig } from "./apps/plm/routeConfig";
import { searchRouteConfig } from "./apps/search/routeConfig";

Vue.use(Router);

const router = new Router({
  mode: "history",
  linkActiveClass: "open active",
  routes: [
    {
      path: "/",
      redirect: "/home",
      name: "Home",
      component: DefaultContainer,
      children: [
        {
          path: "/home",
          name: "HomePage",
          component: HomePage,
        },

        plmRouteConfig,
        managementRouteConfig,
        searchRouteConfig,
      ],
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "404",
          name: "Page 404",
          component: Page404,
        },
      ],
    },
    { path: "*", name: "Not found", redirect: "/pages/404" },
  ],
});

export default router;
